import { createContext, useContext, useState } from "react";
import axios from "axios";

// Without a timeout, a request made over weak wifi can stay pending
// indefinitely: the promise never rejects, so callers' catch blocks never run
// and a lost scan or qty save looks exactly like a successful one. 15s is well
// above a normal round trip here and well below an operator's patience.
axios.defaults.timeout = 15000;

const readStoredAuth = () => {
  try {
    const data = localStorage.getItem("auth");
    if (!data) return { user: null, token: "" };
    const parseData = JSON.parse(data);
    return { user: parseData.user, token: parseData.token };
  } catch (error) {
    // Corrupt or partial localStorage entry - start signed out rather than crash
    return { user: null, token: "" };
  }
};

const AuthContext = createContext();
const AuthProvider = ({ children }) => {
  // Read synchronously on first render so the very first request already
  // carries the token. Doing this in useEffect let child pages fire their
  // requests before the header was set.
  const [auth, setAuth] = useState(readStoredAuth);

  if (auth?.token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }

  return (
    <AuthContext.Provider value={[auth, setAuth]}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom Hook
const useAuth = () => useContext(AuthContext);

export { useAuth, AuthProvider };
